import axios from '../../config/axios';

// دوال الوصول العام للدورات
const getPublicCourses = async (params = {}) => {
  try {
    const response = await axios.get('/api/courses', { params });
    return response.data;
  } catch (error) {
    // Error fetching public courses
    throw error;
  }
};

const getPublicCourseById = async (courseId) => {
  try {
    const response = await axios.get(`/api/courses/${courseId}`);
    return response.data;
  } catch (error) {
    // Error fetching public course
    throw error;
  }
};

// دوال الوصول الإداري للدورات
const getAll = async (params = {}) => {
  const response = await axios.get('/api/admin/courses', { params });
  // التأكد من إرجاع مصفوفة دائمًا
  return Array.isArray(response.data) ? response.data : (response.data.data ? response.data.data : []);
};

const getById = async (id) => {
  const response = await axios.get(`/api/admin/courses/${id}`);
  return response;
};

const create = async (data) => {
  const formData = new FormData();
  
  // أضف البيانات الأساسية
  formData.append('name', data.name);
  formData.append('description', data.description);
  // حقل ماذا ستتعلم؟
  formData.append('whatYouWillLearn', data.whatYouWillLearn || '');
  formData.append('course_type', data.courseType);
  formData.append('price', data.price);
  formData.append('duration', data.duration);
  formData.append('category_id', data.category);
  formData.append('status', data.status);
  formData.append('ask_instructor', data.askInstructor);
  formData.append('is_coming_soon', data.isComingSoon ? 1 : 0);
  
  // إضافة بيانات الخصم
  formData.append('has_discount', data.hasDiscount ? 1 : 0);
  if (data.hasDiscount) {
    formData.append('discount_type', data.discountType || 'percentage');
    formData.append('discount_value', data.discountValue || '0');
    formData.append('discount_start_date', data.discount_start_date || data.discountStart || '');
    formData.append('discount_end_date', data.discount_end_date || data.discountEnd || '');
  }
  
  // أضف التواريخ إذا كانت موجودة
  if (data.startDate) formData.append('start_date', data.startDate);
  if (data.endDate) formData.append('end_date', data.endDate);
  
  // أضف الصور إذا كانت موجودة
  if (data.coverImage) formData.append('cover_image', data.coverImage);
  if (data.planImage) formData.append('plan_image', data.planImage);
  
  // أضف المدربين إذا كانوا موجودين
  if (data.instructors && data.instructors.length > 0) {
    data.instructors.forEach((instructor, index) => {
      formData.append(`instructors[${index}]`, instructor.id);
    });
  }
  
  // أضف الأقسام والدروس إذا كانت موجودة
  if (data.sections && data.sections.length > 0) {
    data.sections.forEach((section, sIndex) => {
      formData.append(`sections[${sIndex}][title]`, section.title || '');
      formData.append(`sections[${sIndex}][description]`, section.description || '');
      formData.append(`sections[${sIndex}][order]`, section.order ?? sIndex);

      if (section.lessons && section.lessons.length > 0) {
        section.lessons.forEach((lesson, lIndex) => {
          const base = `sections[${sIndex}][lessons][${lIndex}]`;
          formData.append(`${base}[title]`, lesson.title || '');
          formData.append(`${base}[description]`, lesson.description || '');
          formData.append(`${base}[type]`, lesson.type);
          formData.append(`${base}[content_url]`, lesson.content_url || '');
          formData.append(`${base}[content_text]`, lesson.content_text || '');
          formData.append(`${base}[duration]`, lesson.duration || '');
          formData.append(`${base}[is_free]`, lesson.is_free ? 1 : 0);
          formData.append(`${base}[order]`, lesson.order ?? lIndex);
          // TODO: handle file uploads if type === 'file' later
        });
      }
    });
  }
  
  const response = await axios.post('/api/admin/courses', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  
  return response.data;
};

const update = async (id, data) => {
  const formData = new FormData();
  
  // أضف البيانات الأساسية
  formData.append('name', data.name || '');
  formData.append('description', data.description || '');
  // حقل ماذا ستتعلم؟
  formData.append('whatYouWillLearn', data.whatYouWillLearn || '');
  formData.append('course_type', data.courseType || 'free');
  formData.append('price', data.price || '0');
  formData.append('duration', data.duration || '');
  formData.append('category_id', data.category || '');
  formData.append('status', data.status || 'draft');
  formData.append('ask_instructor', data.askInstructor || 'enabled');
  formData.append('is_coming_soon', data.isComingSoon ? 1 : 0);
  
  // إضافة بيانات الخصم
  formData.append('has_discount', data.hasDiscount ? 1 : 0);
  if (data.hasDiscount) {
    formData.append('discount_type', data.discountType || 'percentage');
    formData.append('discount_value', data.discountValue || '0');
    formData.append('discount_start_date', data.discount_start_date || data.discountStart || '');
    formData.append('discount_end_date', data.discount_end_date || data.discountEnd || '');
  }
  
  // أضف التواريخ إذا كانت موجودة
  if (data.startDate) formData.append('start_date', data.startDate);
  if (data.endDate) formData.append('end_date', data.endDate);
  
  // أضف الصور إذا كانت موجودة
  if (data.coverImage) formData.append('cover_image', data.coverImage);
  if (data.planImage) formData.append('plan_image', data.planImage);
  
  // أضف المدربين إذا كانوا موجودين
  if (data.instructors && data.instructors.length > 0) {
    data.instructors.forEach((instructor, index) => {
      formData.append(`instructors[${index}]`, instructor.id);
    });
  } else {
    // إذا لم يكن هناك مدربين، أرسل مصفوفة فارغة
    formData.append('instructors', JSON.stringify([]));
  }
  
  // أضف الأقسام والدروس إذا كانت موجودة
  if (data.sections && data.sections.length > 0) {
    data.sections.forEach((section, sIndex) => {
      formData.append(`sections[${sIndex}][title]`, section.title || '');
      formData.append(`sections[${sIndex}][description]`, section.description || '');
      formData.append(`sections[${sIndex}][order]`, section.order ?? sIndex);

      if (section.lessons && section.lessons.length > 0) {
        section.lessons.forEach((lesson, lIndex) => {
          const base = `sections[${sIndex}][lessons][${lIndex}]`;
          formData.append(`${base}[title]`, lesson.title || '');
          formData.append(`${base}[description]`, lesson.description || '');
          formData.append(`${base}[type]`, lesson.type);
          formData.append(`${base}[content_url]`, lesson.content_url || '');
          formData.append(`${base}[content_text]`, lesson.content_text || '');
          formData.append(`${base}[duration]`, lesson.duration || '');
          formData.append(`${base}[is_free]`, lesson.is_free ? 1 : 0);
          formData.append(`${base}[order]`, lesson.order ?? lIndex);
        });
      }
    });
  }
  
  // Update course data debug information
  
  try {
    // استخدام POST مع _method=PUT
    formData.append('_method', 'PUT');
    
    const response = await axios.post(`/api/admin/courses/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    // API Error
    throw error;
  }
};

const updateStatus = async (id, status) => {
  try {
    // Updating course status
    
    const response = await axios.post(`/api/admin/courses/${id}/status`, { status });
    
    return response.data;
  } catch (error) {
    // API Error updating status
    throw error;
  }
};

const remove = async (id) => {
  await axios.delete(`/api/admin/courses/${id}`);
};

const getCategories = async () => {
  const response = await axios.get('/api/admin/courses/categories/all');
  return response.data;
};

const resetEnrollments = async (courseId) => {
  const response = await axios.post(`/api/admin/courses/${courseId}/reset-enrollments`);
  return response.data;
};

const enrollStudent = async (courseId, userId) => {
  const response = await axios.post(`/api/admin/courses/${courseId}/enroll`, { user_id: userId });
  return response.data;
};

const getInstructors = async () => {
  const response = await axios.get('/api/admin/courses/instructors/all');
  return response.data;
};

// ==================== دوال إدارة محتوى الدورة ====================

// جلب أقسام ودروس الدورة
const getCourseContent = async (courseId) => {
  // Fetching course content
  
  const response = await axios.get(`/api/admin/courses/${courseId}/content`, {
    // إضافة معلمة لمنع الكاش
    params: { _t: new Date().getTime() }
  });
  
  // Course content response
  return response.data;
};

// إضافة قسم جديد
const addSection = async (courseId, sectionData) => {
  const response = await axios.post(`/api/admin/courses/${courseId}/sections`, sectionData);
  return response.data;
};

// تعديل قسم
const updateSection = async (sectionId, sectionData) => {
  try {
    const response = await axios.put(`/api/admin/courses/sections/${sectionId}`, sectionData);
    // Section updated
    return response.data;
  } catch (error) {
    // Error updating section
    throw error;
  }
};

// حذف قسم
const deleteSection = async (sectionId) => {
  try {
    await axios.delete(`/api/admin/courses/sections/${sectionId}`);
    // Section deleted successfully
  } catch (error) {
    // Error deleting section
    throw error;
  }
};

// تحديث ترتيب الأقسام
const updateSectionsOrder = async (courseId, sectionsOrder) => {
  // Updating sections order
  
  const response = await axios.put(`/api/admin/courses/${courseId}/sections/order`, {
    order: sectionsOrder
  });
  // Sections order updated
  
  // إذا كان الرد يحتوي على الأقسام المحدثة، نقوم بتحديث الكاش
  if (response.data.sections) {
    // Received updated sections from server
  }
  
  return response.data;
};

// إضافة درس جديد
const addLesson = async (sectionId, lessonData, onProgress) => {
  const formData = new FormData();
  formData.append('title', lessonData.title);
  formData.append('description', lessonData.description || '');
  
  // إضافة حقل is_free
  formData.append('is_free', lessonData.is_free ? '1' : '0');
  
  // إرسال نوع الدرس مباشرة إلى قاعدة البيانات
  formData.append('type', lessonData.type);
  
  formData.append('duration', lessonData.duration || '0');
  formData.append('order', lessonData.order || 0);
  
  // إضافة المحتوى حسب النوع
  if (lessonData.type === 'video_url') {
    formData.append('content_url', lessonData.content_url || '');
  } else if (lessonData.type === 'video_embed') {
    formData.append('content_url', lessonData.content_url || '');
  } else if (lessonData.type === 'video_file') {
    // Video file details before upload
    formData.append('video_file', lessonData.video_file);
  } else if (lessonData.type === 'text') {
    formData.append('content_text', lessonData.content_text || '');
  } else if (lessonData.type === 'file') {
    formData.append('file', lessonData.file);
    // File appended to FormData
  }

  try {
    // FormData entries for debugging
  
    const response = await axios.post(`/api/admin/courses/sections/${sectionId}/lessons`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 600000, // 10 دقائق (600000 مللي ثانية)
      onUploadProgress: (progressEvent) => {
        if (progressEvent.lengthComputable && onProgress) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percentCompleted);
        }
      }
    });

    const lesson = response.data.lesson || response.data;
    
    // تحويل نوع الدرس إلى الصيغة المستخدمة في الفرونت إند
    if (lesson.type === 'video') {
      if (lesson.content_url && lesson.content_url.startsWith('/storage/course_videos/')) {
        lesson.type = 'video_file';
      } else {
        lesson.type = 'video_url';
      }
    }
    
    return lesson;
  } catch (error) {
    // Error adding lesson
    // Error response data
    throw error;
  }
};

// تعديل درس
const updateLesson = async (lessonId, lessonData) => {
  // استخدام FormData لدعم رفع الملفات
  const formData = new FormData();
  
  // إضافة البيانات الأساسية
  formData.append('title', lessonData.title);
  formData.append('description', lessonData.description || '');
  formData.append('duration', lessonData.duration || '0');
  formData.append('is_free', lessonData.is_free ? '1' : '0');
  
  // إرسال نوع الدرس الأصلي إلى الباك إند بدون تحويل
  formData.append('type', lessonData.type);
  // Sending original lesson type to server
  
  // إضافة المحتوى حسب النوع
  if (lessonData.type === 'video_url') {
    formData.append('content_url', lessonData.content_url);
  } else if (lessonData.type === 'video_embed') {
    // إرسال كود الإمبد ليتم حفظه في الباك إند
    if (lessonData.content_url) {
      formData.append('content_url', lessonData.content_url);
    }
  } else if (lessonData.type === 'video_file') {
    // إذا كان هناك ملف فيديو، أرسله
    if (lessonData.video_file) {
      formData.append('video_file', lessonData.video_file);
    }
    // إذا كان هناك رابط فيديو، أرسله
    if (lessonData.content_url) {
      formData.append('content_url', lessonData.content_url);
    }
  } else if (lessonData.type === 'text') {
    formData.append('content_text', lessonData.content_text);
  } else if (lessonData.type === 'file') {
    // إذا كان هناك ملف، أرسله
    if (lessonData.file) {
      formData.append('file', lessonData.file);
      // File appended to FormData for update
    }
    // إذا كان هناك رابط، أرسله
    if (lessonData.content_url) {
      formData.append('content_url', lessonData.content_url);
    }
  }
  
  // FormData contents for debugging
  
  try {
    // استخدام طلب POST مع _method=PUT
    formData.append('_method', 'PUT');
    
    const response = await axios.post(`/api/admin/courses/lessons/${lessonId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    // Response received from server
    
    // تحويل البيانات المستلمة إلى الصيغة المتوقعة في الفرونت إند
    const lesson = response.data.lesson || response.data;
    
    // تحويل نوع الدرس إلى الصيغة المستخدمة في الفرونت إند
    if (lesson.type === 'video') {
      if (lesson.content_url && lesson.content_url.startsWith('/storage/course')) {
        lesson.type = 'video_file';
      } else {
        lesson.type = 'video_url';
      }
    }
    
    // التأكد من تحديث lesson_type لنوع video_embed
    if (lesson.type === 'video_embed') {
      lesson.lesson_type = 'video_embed';
      // Setting lesson_type for video_embed
    }
    
    return lesson;
  } catch (error) {
    // Error updating lesson
    // طباعة تفاصيل الخطأ للتشخيص
    if (error.response) {
      // Error response data
      // Error response status
      // Error response headers
    }
    throw error;
  }
};

// حذف درس
const deleteLesson = async (lessonId) => {
  try {
    const response = await axios.delete(`/api/admin/courses/lessons/${lessonId}`);
    // Lesson deleted successfully
    return response.data;
  } catch (error) {
    // Error deleting lesson
    throw error;
  }
};

// تحديث ترتيب الدروس
const updateLessonsOrder = async (sectionId, lessonsOrder) => {
  // Updating lessons order
  
  const response = await axios.put(`/api/admin/courses/sections/${sectionId}/lessons/order`, {
    order: lessonsOrder
  });
  // Lessons order updated
  return response.data;
};

// تحديث ترتيب الحقائب
const updateResourcesOrder = async (sectionId, resourcesOrder) => {
  // Updating resources order
  
  const response = await axios.put(`/api/admin/courses/sections/${sectionId}/resources/order`, {
    order: resourcesOrder
  });
  // Resources order updated
  return response.data;
};

// تغيير حالة الدرس (نشر/إخفاء)
const toggleLessonStatus = async (lessonId) => {
  try {
    const response = await axios.post(`/api/admin/courses/lessons/${lessonId}/toggle-status`);
    // Lesson status toggled
    return response.data;
  } catch (error) {
    // Error toggling lesson status
    throw error;
  }
};

// تغيير حالة القسم (نشر/إخفاء)
const toggleSectionStatus = async (sectionId) => {
  try {
    const response = await axios.put(`/api/admin/courses/sections/${sectionId}/toggle-status`);
    return response.data;
  } catch (error) {
    // Error toggling section status
    throw error;
  }
};

// إضافة حقيبة تعليمية جديدة
const addResource = async (sectionId, resourceData, onProgress) => {
  try {
    // Adding resource to section
    // Resource data
    
    const formData = new FormData();
    formData.append('section_id', sectionId);
    formData.append('title', resourceData.title);
    formData.append('description', resourceData.description || '');
    formData.append('allow_download', resourceData.allowDownload ? 1 : 0);
    formData.append('is_free', resourceData.is_free ? 1 : 0);
    formData.append('type', resourceData.type);
    
    // إضافة الملف أو الرابط حسب النوع
    if (resourceData.type === 'file' && resourceData.file) {
      formData.append('file', resourceData.file);
    } else if (resourceData.type === 'link' && resourceData.url) {
      formData.append('url', resourceData.url);
    }
    
    // إضافة حقل الترتيب
    formData.append('order', resourceData.order || 0);
    
    const response = await axios.post(
      `/api/admin/courses/sections/${sectionId}/resources`,
      formData,
      {
        timeout: 600000, // 10 دقائق لرفع الملفات
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (event) => {
          if (onProgress && event.total) {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress(percent);
          }
        }
      }
    );
    
    // Resource added successfully
    return response.data;
  } catch (error) {
    // Error adding resource
    throw error;
  }
};

// تحديث حقيبة تعليمية
const updateResource = async (resourceId, resourceData) => {
  try {
    // Updating resource
    // Resource data
    
    const formData = new FormData();
    // نزيل _method: PUT لأن الخادم يتوقع طلب POST مباشر
    formData.append('title', resourceData.title);
    formData.append('description', resourceData.description || '');
    formData.append('allow_download', resourceData.allowDownload ? 1 : 0);
    formData.append('is_free', resourceData.is_free ? 1 : 0);
    
    // إضافة الملف أو الرابط حسب النوع
    if (resourceData.type === 'file' && resourceData.file) {
      formData.append('file', resourceData.file);
    } else if (resourceData.type === 'link' && resourceData.url) {
      formData.append('url', resourceData.url);
    }
    
    const response = await axios.post(
      `/api/admin/courses/resources/${resourceId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    
    // Resource updated successfully
    return response.data;
  } catch (error) {
    // Error updating resource
    throw error;
  }
};

// حذف حقيبة تعليمية
const deleteResource = async (resourceId) => {
  try {
    // Deleting resource
    
    const response = await axios.delete(
      `/api/admin/courses/resources/${resourceId}`
    );
    
    // Resource deleted successfully
    return response.data;
  } catch (error) {
    // Error deleting resource
    throw error;
  }
};

// تغيير حالة حقيبة تعليمية (نشر/إخفاء)
const toggleResourceStatus = async (resourceId) => {
  try {
    // Toggling resource status
    
    const response = await axios.put(
      `/api/admin/courses/resources/${resourceId}/toggle-status`
    );
    
    // Resource status toggled successfully
    return response.data;
  } catch (error) {
    // Error toggling resource status
    throw error;
  }
};

// إضافة قروب جديد
const addGroup = async (sectionId, groupData) => {
  try {
    // Adding group to section
    // Group data
    
    const response = await axios.post(`/api/admin/courses/sections/${sectionId}/groups`, groupData);
    return response.data;
  } catch (error) {
    // Error adding group
    throw error;
  }
};

// تحديث ترتيب القروبات
const updateGroupsOrder = async (sectionId, groupsOrder) => {
    // Updating groups order
  
  try {
    const response = await axios.put(`/api/admin/courses/sections/${sectionId}/groups/order`, {
      groups: groupsOrder
    });
    return response.data;
  } catch (error) {
    // Error updating groups order
    throw error;
  }
};

// تغيير حالة القروب (نشر/إخفاء)
const toggleGroupStatus = async (groupId) => {
  try {
    const response = await axios.put(`/api/admin/courses/groups/${groupId}/toggle-status`);
    return response.data;
  } catch (error) {
    // Error toggling group status
    throw error;
  }
};

// حذف قروب
const deleteGroup = async (groupId) => {
  try {
    const response = await axios.delete(`/api/admin/courses/groups/${groupId}`);
    return response.data;
  } catch (error) {
    // Error deleting group
    throw error;
  }
};

// تحديث بيانات قروب
const updateGroup = async (groupId, groupData) => {
  try {
    const response = await axios.post(`/api/admin/courses/groups/${groupId}`, groupData);
    return response.data;
  } catch (error) {
    // Error updating group
    throw error;
  }
};

// ==================== دوال إدارة الاختبارات ====================

// جلب قائمة الاختبارات
const getExams = async (params = {}) => {
  try {
    const response = await axios.get('/api/admin/courses/exams', { params });
    return response.data;
  } catch (error) {
    // Error fetching exams
    throw error;
  }
};

// جلب اختبار محدد
const getExamById = async (examId) => {
  try {
    const response = await axios.get(`/api/admin/courses/exams/${examId}`);
    return response.data;
  } catch (error) {
    // Error fetching exam
    throw error;
  }
};

// جلب قائمة الدورات للاختبار
const getCoursesForExam = async () => {
  try {
    const response = await axios.get('/api/admin/courses/exams/courses');
    return response.data;
  } catch (error) {
    // Error fetching courses for exam
    throw error;
  }
};

// إنشاء اختبار جديد
const createExam = async (examData) => {
  try {
    const formData = new FormData();
    
    // البيانات الأساسية
    formData.append('title', examData.title);
    formData.append('description', examData.description || '');
    formData.append('course_id', examData.course_id);
    formData.append('duration', examData.duration || 0);
    formData.append('total_score', examData.total_score || 0);
    formData.append('passing_score', examData.passing_score || 0);
    formData.append('status', examData.status || 'draft');
    
    // الإعدادات المتقدمة
    formData.append('retry_limit', examData.retry_limit ? 1 : 0);
    formData.append('attempts_allowed', examData.attempts_allowed || 0);
    formData.append('is_randomized', examData.is_randomized ? 1 : 0);
    formData.append('show_results', examData.show_results ? 1 : 0);
    formData.append('skippable', examData.skippable === undefined ? 0 : (examData.skippable ? 1 : 0));
    formData.append('is_free', examData.is_free === undefined ? 0 : (examData.is_free ? 1 : 0));
    
    // التواريخ
    if (examData.startDate) {
      formData.append('start_date', examData.startDate);
    }
    if (examData.endDate) {
      formData.append('end_date', examData.endDate);
    }
    
    const response = await axios.post('/api/admin/courses/exams', formData);
    return response.data;
  } catch (error) {
    // Error creating exam
    throw error;
  }
};

// تحديث اختبار
const updateExam = async (examId, examData) => {
  try {
    const formData = new FormData();
    
    // البيانات الأساسية
    if (examData.title) formData.append('title', examData.title);
    if (examData.description !== undefined) formData.append('description', examData.description);
    if (examData.courseId) formData.append('course_id', examData.courseId);
    if (examData.duration !== undefined) formData.append('duration', examData.duration);
    if (examData.totalScore !== undefined) formData.append('total_score', examData.totalScore);
    if (examData.passingScore !== undefined) formData.append('passing_score', examData.passingScore);
    if (examData.status) formData.append('status', examData.status);
    
    // الإعدادات المتقدمة
    if (examData.retryLimit !== undefined) formData.append('retry_limit', examData.retryLimit ? 1 : 0);
    if (examData.maxAttempts !== undefined) formData.append('max_attempts', examData.maxAttempts);
    if (examData.skippable !== undefined) formData.append('skippable', examData.skippable ? 1 : 0);
    if (examData.is_free !== undefined) formData.append('is_free', examData.is_free ? 1 : 0);
    
    if (examData.startDate) formData.append('start_date', examData.startDate);
    if (examData.endDate) formData.append('end_date', examData.endDate);
    
    // استخدام POST مع _method=PUT
    formData.append('_method', 'PUT');
    
    // إرسال البيانات للباك إند
    const response = await axios.post(`/api/admin/courses/exams/${examId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    // Error updating exam
    throw error;
  }
};

// حذف اختبار
const deleteExam = async (examId) => {
  try {
    const response = await axios.delete(`/api/admin/courses/exams/${examId}`);
    return response.data;
  } catch (error) {
    // Error deleting exam
    throw error;
  }
};

// تغيير حالة الاختبار (نشر/مسودة)
const toggleExamStatus = async (examId) => {
  try {
    const response = await axios.put(`/api/admin/courses/exams/${examId}/toggle-status`);
    return response.data;
  } catch (error) {
    // Error toggling exam status
    throw error;
  }
};

// ==================== دوال إدارة أسئلة الاختبار ====================

// جلب أسئلة الاختبار
const getExamQuestions = async (examId) => {
  try {
    const response = await axios.get(`/api/admin/courses/exams/${examId}/questions`);
    return response.data;
  } catch (error) {
    // Error fetching exam questions
    throw error;
  }
};

// إضافة سؤال جديد للاختبار
const addExamQuestion = async (examId, questionData) => {
  try {
    const formData = new FormData();
    
    // بيانات السؤال
    formData.append('text', questionData.text);
    formData.append('score', questionData.score);
    if (questionData.instructions) formData.append('instructions', questionData.instructions);
    if (questionData.notification) formData.append('notification', questionData.notification);
    
    // صورة السؤال إن وجدت
    if (questionData.image) formData.append('image', questionData.image);
    
    // إضافة الإجابات
    if (questionData.answers && questionData.answers.length > 0) {
      questionData.answers.forEach((answer, index) => {
        formData.append(`answers[${index}][text]`, answer.text);
        formData.append(`answers[${index}][is_correct]`, answer.isCorrect ? 1 : 0);
        if (answer.image) formData.append(`answers[${index}][image]`, answer.image);
      });
    }
    
    const response = await axios.post(`/api/admin/courses/exams/${examId}/questions`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    // Error adding exam question
    throw error;
  }
};

// تحديث سؤال
const updateExamQuestion = async (examId, questionId, questionData) => {
  try {
    const formData = new FormData();
    
    // بيانات السؤال
    if (questionData.text) formData.append('text', questionData.text);
    if (questionData.score !== undefined) formData.append('score', questionData.score);
    if (questionData.instructions !== undefined) formData.append('instructions', questionData.instructions);
    if (questionData.notification !== undefined) formData.append('notification', questionData.notification);
    
    // صورة السؤال إن وجدت
    if (questionData.image) formData.append('image', questionData.image);
    
    // تحديث الإجابات
    if (questionData.answers && questionData.answers.length > 0) {
      questionData.answers.forEach((answer, index) => {
        if (answer.id) formData.append(`answers[${index}][id]`, answer.id);
        formData.append(`answers[${index}][text]`, answer.text);
        formData.append(`answers[${index}][is_correct]`, answer.isCorrect ? 1 : 0);
        if (answer.image && typeof answer.image !== 'string') {
          formData.append(`answers[${index}][image]`, answer.image);
        }
      });
    }
    
    // استخدام POST مع _method=PUT
    formData.append('_method', 'PUT');
    
    const response = await axios.post(`/api/admin/courses/exams/${examId}/questions/${questionId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    // Error updating exam question
    throw error;
  }
};

// حذف سؤال (حذف ناعم)
const deleteExamQuestion = async (examId, questionId) => {
  try {
    const response = await axios.delete(`/api/admin/courses/exams/${examId}/questions/${questionId}`);
    return response.data;
  } catch (error) {
    // Error soft deleting exam question
    throw error;
  }
};

// حذف سؤال نهائياً (للاستخدام مع نقطة النهاية الجديدة في الباكند)
const permanentDeleteExamQuestion = async (examId, questionId) => {
  try {
    // استخدام نقطة النهاية الجديدة للحذف النهائي
    const response = await axios.delete(`/api/admin/courses/exams/${examId}/questions/${questionId}/permanent-delete`);
    return response.data;
  } catch (error) {
    // Error permanently deleting exam question
    throw error;
  }
};

// تغيير ترتيب الأسئلة
const reorderExamQuestions = async (examId, questionsOrder) => {
  try {
    const response = await axios.put(`/api/admin/courses/exams/${examId}/questions/reorder`, {
      questions: questionsOrder
    });
    return response.data;
  } catch (error) {
    // Error reordering exam questions
    throw error;
  }
};

// ==================== دوال إدارة إجابات الأسئلة ====================

// جلب إجابات سؤال محدد
const getQuestionAnswers = async (questionId) => {
  try {
    const response = await axios.get(`/api/admin/courses/exams/questions/${questionId}/answers`);
    return response.data;
  } catch (error) {
    // Error fetching question answers
    throw error;
  }
};

// إضافة إجابة جديدة
const addQuestionAnswer = async (questionId, answerData) => {
  try {
    const formData = new FormData();
    
    formData.append('text', answerData.text);
    formData.append('is_correct', answerData.isCorrect ? 1 : 0);
    
    if (answerData.image) formData.append('image', answerData.image);
    
    const response = await axios.post(`/api/admin/courses/exams/questions/${questionId}/answers`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    // Error adding question answer
    throw error;
  }
};

// تحديث إجابة
const updateQuestionAnswer = async (answerId, answerData) => {
  try {
    const formData = new FormData();
    
    if (answerData.text) formData.append('text', answerData.text);
    if (answerData.isCorrect !== undefined) formData.append('is_correct', answerData.isCorrect ? 1 : 0);
    
    if (answerData.image && typeof answerData.image !== 'string') {
      formData.append('image', answerData.image);
    }
    
    // استخدام POST مع _method=PUT
    formData.append('_method', 'PUT');
    
    const response = await axios.post(`/api/admin/courses/exams/answers/${answerId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    // Error updating question answer
    throw error;
  }
};

// حذف إجابة
const deleteQuestionAnswer = async (answerId) => {
  try {
    const response = await axios.delete(`/api/admin/courses/exams/answers/${answerId}`);
    return response.data;
  } catch (error) {
    // Error deleting question answer
    throw error;
  }
};

// تغيير ترتيب الإجابات
const reorderQuestionAnswers = async (questionId, answersOrder) => {
  try {
    const response = await axios.put(`/api/admin/courses/exams/questions/${questionId}/answers/reorder`, {
      answers: answersOrder
    });
    return response.data;
  } catch (error) {
    // Error reordering question answers
    throw error;
  }
};

// ربط اختبار بقسم في الدورة
const linkExamToSection = async (sectionId, examId) => {
  try {
    const response = await axios.post(`/api/admin/courses/sections/${sectionId}/exams`, {
      exam_id: examId,
      order: 0 // الترتيب الافتراضي
    });
    return response.data;
  } catch (error) {
    // Error linking exam to section
    throw error;
  }
};

// جلب محتوى القسم مرتباً
const getOrderedContent = async (sectionId) => {
  try {
    const response = await axios.get(`/api/admin/courses/sections/${sectionId}/ordered-content`);
    return response.data;
  } catch (error) {
    // Error fetching ordered content
    throw error;
  }
};

// تحديث ترتيب المحتوى
const updateContentOrder = async (sectionId, data) => {
  try {
    const response = await axios.put(`/api/admin/courses/sections/${sectionId}/content/order`, data);
    return response.data;
  } catch (error) {
    // Error updating content order
    throw error;
  }
};

// جلب اختبارات قسم معين
const getSectionExams = async (sectionId) => {
  try {
    const response = await axios.get(`/api/admin/courses/sections/${sectionId}/exams`);
    return response.data;
  } catch (error) {
    // Error fetching section exams
    throw error;
  }
};

// فك ارتباط اختبار من قسم (حذف الاختبار من القسم بدون حذف الاختبار نفسه)
const unlinkExamFromSection = async (sectionId, examId) => {
  try {
    const response = await axios.delete(`/api/admin/courses/sections/${sectionId}/exams/${examId}`);
    return response.data;
  } catch (error) {
    // Error unlinking exam from section
    throw error;
  }
};



export const coursesApi = {
  // دوال الوصول العام للدورات
  getPublicCourses,
  getPublicCourseById,
  
  // دوال الوصول الإداري للدورات
  getAll,
  getById,
  create,
  update,
  updateStatus,
  remove,
  getCategories,
  getInstructors,
  resetEnrollments,
  enrollStudent,
  
  // دوال محتوى الدورة
  getCourseContent,
  addSection,
  updateSection,
  deleteSection,
  updateSectionsOrder,
  addLesson,
  updateLesson,
  deleteLesson,
  updateLessonsOrder,
  toggleLessonStatus,
  toggleSectionStatus,
  
  // دوال الحقيبة التعليمية
  addResource,
  updateResource,
  deleteResource,
  toggleResourceStatus,
  updateResourcesOrder,
  
  // دوال القروبات
  addGroup,
  updateGroupsOrder,
  toggleGroupStatus,
  deleteGroup,
  updateGroup,
  
  // دوال الاختبارات
  getExams,
  getExamById,
  getSectionExams,
  linkExamToSection,
  unlinkExamFromSection,
  toggleExamStatus,
  getOrderedContent,
  updateContentOrder,
  getCoursesForExam: async () => {
    try {
      const response = await axios.get('/api/admin/courses/exams/courses');
      return response.data;
    } catch (error) {
      // Error fetching courses for exam
      throw error;
    }
  },
  createExam,
  updateExam,
  deleteExam,
  toggleExamStatus,
  
  // دوال أسئلة الاختبار
  getExamQuestions,
  addExamQuestion,
  updateExamQuestion,
  deleteExamQuestion,
  permanentDeleteExamQuestion,
  reorderExamQuestions,
  
  // دوال إجابات الأسئلة
  getQuestionAnswers,
  addQuestionAnswer,
  updateQuestionAnswer,
  deleteQuestionAnswer,
  reorderQuestionAnswers,
  
  // دوال ربط الاختبارات
  linkExamToSection,
  getSectionExams
};
